export const LANGUAGE_STRINGS = {
  English: _TL_('English'),
  German: _TL_('German'),
  French: _TL_('French'),
  Spanish: _TL_('Spanish'),
  Italian: _TL_('Italian'),
  Portuguese: _TL_('Portuguese'),
  Dutch: _TL_('Dutch'),
  Swedish: _TL_('Swedish'),
  TraditionalChinese: _TL_('Traditional Chinese'),
  Danish: _TL_('Danish'),
  Finnish: _TL_('Finnish'),
  Norwegian: _TL_('Norwegian'),

  Bulgarian: _TL_('Bulgarian'),
  Croatian: _TL_('Croatian'),
  Czech: _TL_('Czech'),
  Estonian: _TL_('Estonian'),
  Greek: _TL_('Greek'),
  Hungarian: _TL_('Hungarian'),
  Latvian: _TL_('Latvian'),
  Lithuanian: _TL_('Lithuanian'),
  Maltese: _TL_('Maltese'),
  Polish: _TL_('Polish'),
  Romanian: _TL_('Romanian'),
  Slovak: _TL_('Slovak'),
  Slovenian: _TL_('Slovenian'),

  Albanian: _TL_('Albanian'),
  Bosnian: _TL_('Bosnian'),
  Icelandic: _TL_('Icelandic'),
  Macedonian: _TL_('Macedonian'),
  Serbian: _TL_('Serbian'),
  Turkish: _TL_('Turkish'),

  Japanese: _TL_('Japanese'),
  Russian: _TL_('Russian'),
  Hebrew: _TL_('Hebrew'),
  Arabic: _TL_('Arabic'),

  SimplifiedChinese: _TL_('Simplified Chinese'),

  Hindi: _TL_('Hindi'),
  Malay: _TL_('Malay'),
  Thai: _TL_('Thai'),
  Indonesian: _TL_('Indonesian'),
  Tagalog: _TL_('Tagalog'),
  Vietnamese: _TL_('Vietnamese'),
};
